import { displayNumber } from 'utils/misc';

type Props = {
  value: number;
  align?: 'left' | 'right';
};
export default function PercentageDisplay(props: Props) {
  const { value, align } = props;

  return (
    <div style={{ textAlign: align || 'right' }}>
      {displayNumber(value * 100, 1)} %
    </div>
  );
}
